module.exports = __webpack_public_path__ + "static/media/facebook.46911923.svg";